import { Guid } from "@syncfusion/ej2/pdf-export";

export class exceededhourBO {
    orderColumn: string="name";
    orderType: string="asc";
    pageitem: number=10;
    currentpageno: number=1;
    agencyId: string;
    field: string="name";
    value: string="";
    matchCase: boolean =false ;
    operator: string="contains";
    type: string="string";
    locationId: string|null;
}


export class UploadLeieBO {
    fileName: string;
    file: string;
}

export class GetListBO {
    spendownfilter: boolean | null;
    ptype: string | null;
    role: string;
    user: string | null;
    menuID: string | null;
    parentMenuID: string | null;
    searchColumn: string;
    searchText: string;
    orderColumn: string="id";
    orderType: string="asc";
    pageitem: number=10;
    currentpageno: number=1;
    agencyID: string | null;
    listId: string | null;
    lovCode: string | null;
    userId: string | null;
    field: string="id";
    value: string="0";
    matchCase: boolean=false;
    operator: string="greaterthanorequal";
    type: string="string";
    locationId: string|null;
    isEvv: boolean;
}
export class claimdashboardreturnBO {
    paidtotal: number;
    progresstotal: number;
    deniedtotal: number;
    partialypaidtotal: number;
    paidAmout: number;
    deniedAmout: number;
    partialypaidAmount: number;
    progressAmount: number;
}

// export class ClaimdashboardBO {
//     groupId: number | null=0;
//     payorId: number | null=0;
//     agencyId: number | null=0;
//     locationId: number | null=0;
// }
export class ClaimdashboardBO {
    groupId: string | null;
    payorId: string | null;
    agencyId: string | null;
    locationId: string | null;
    is837I: boolean;
    claimStatus: string;
}


export class GetExpiringAuthListBO
{
orderColumn: string="clientName";
orderType: string="asc";
pageitem: number=10;
currentpageno: number=1;
agencyId: string;
field: string="clientName";
value: string="";
matchCase: boolean;
operator: string="contains";
type: string="string";
locationId: string|null;
fromDate: string | null;
toDate: string | null;
}




export class getExcludedOigListeBase {
  
    currentpageno: number = 1;
     pageitem: number = 10;
     orderColumn: string = "name";
     orderType: string = "asc";
     type: string = "string";
     field: string = "name";
     operator: string = "startswith";
     value: string = "";
     matchCase: boolean = false;
   }

export class pgmTypeBO {
    orderColumn: string="name";
    orderType: string="asc";
    pageitem: number=10;
    currentpageno: number=1;
    agencyId: string;
    field: string="name";
    value: string="";
    matchCase: boolean =false ;
    operator: string="contains";
    type: string="string";
    locationId: string|null;
    pgmTypeLid: Guid;
}
